import React, { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import * as contractfile from "../helper/contractData";
import { toast } from "react-toastify";
import Button from "react-bootstrap-button-loader";
import * as constdata from "../hooks/constant";
import { parseUnits } from "@ethersproject/units";
import { AddressZero } from "@ethersproject/constants";

import Web3 from "web3";
import { presale_address, presale_abi, token_abi, busd_address, usdt_address } from "../hooks/constant";

import { useAccount } from "wagmi";


export default function Buy() {
  const { address:account} = useAccount();
  const [loading, setLoading] = useState(false);
  const [isApprove, setIsApprove] = useState(true);
  const [paymenttype, setPaymenttype] = useState(false);
  const [busdapprove, setBusdapprove] = useState(false);
  const [usdtapprove, setUsdtapprove] = useState(false);
  const [userbal, setUserBal] = useState(0);
  const [refresh, setRefresh] = useState(new Date());
  const [UsdtoBnb, setUsdtoBnb] = useState(0);
  const [perDollarPrice, setPerDollarPrice] = useState(0);

  const [amount, setAmount] = useState("0.0");
  const [token, setToken] = useState("0.0");
  const [error_msg, setError_msg] = useState("");

  const [contract, setContract] = useState(null);
  const [busd, setBusd] = useState(null);
  const [usdt, setUsdt] = useState(null);
  const web3 = new Web3(Web3.givenProvider);

  const [referral, setReferral] = useState(AddressZero);

  // get referral address
  const getReferral = () => {
    let addr = AddressZero;
    if (window.location.href.includes("?ref=")) {
      addr = window.location.href.substring(
        window.location.href.indexOf("=") + 1
      );
    }
    return addr;
  };

  useEffect(() => {
    setReferral(getReferral());
  }, [account]);

  console.log("referral", referral);


  useEffect(() => {
    
    const _contract = new web3.eth.Contract(presale_abi, presale_address);
    setContract(_contract);

    async function checkApprove() {
      try {
        if (account) {
         

          let busdcontract = new web3.eth.Contract(
            token_abi,
            busd_address
          );

          let usdtcontract = new web3.eth.Contract(
            token_abi,
            usdt_address
          );


          let busdcheck = await busdcontract.methods.allowance(account, presale_address).call();
          let usdtcheck = await usdtcontract.methods.allowance(account, presale_address).call();

          // convert to ether
          busdcheck = web3.utils.fromWei(busdcheck.toString(), "ether");
          usdtcheck = web3.utils.fromWei(usdtcheck.toString(), "ether");

          setBusd(busdcontract);
          setUsdt(usdtcontract);

          if (parseFloat(busdcheck) > 10000) {
            setBusdapprove(true);
          }

          if (parseFloat(usdtcheck) > 10000) {
            setUsdtapprove(true);
          }
        }
      } catch (err) {
        console.log(err.message);
      }
    }

    checkApprove();
  }, [account]);

  useEffect(() => {
    async function getUserBal() {
      console.log("account", account);
      if (account) {
        console.log("account-2", account);
        const contract = new web3.eth.Contract(presale_abi, presale_address);
        let usdtoBnb = await contract.methods.UsdtoEth().call();
        let pdp = await contract.methods.perDollarPrice().call();
        console.log("response", usdtoBnb);
        setUsdtoBnb(usdtoBnb);
        setPerDollarPrice(pdp);
        const token_address = await contract.methods.token().call();
        const token = new web3.eth.Contract(token_abi, token_address);
        let userB = await token.methods.balanceOf(account).call();
        console.log("userB", userB);
        userB = web3.utils.fromWei(userB.toString(), "ether");
        setUserBal(userB);
      }
    }

    getUserBal();
  }, [refresh, account]);

  const handlePaymentChange = async (e) => {
    setPaymenttype(e.target.value);
    console.log(e.target.value);
    if (e.target.value === "1") {
      if (usdtapprove === true) {
        setIsApprove(true);
      } else {
        setIsApprove(false);
      }
    } else if (e.target.value === "2") {
      if (busdapprove === true) {
        setIsApprove(true);
      } else {
        setIsApprove(false);
      }
    } else {
      setIsApprove(true);
    }
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    if (paymenttype !== "3") {
      if (isNaN(e.target.value)) {
        setToken(0);
        setError_msg("(please enter valid amount.)");
        return;
      } else if (parseFloat(e.target.value) === 0) {
        setToken(0);
        setError_msg("(please enter valid amount.)");
        return;
      } else if (parseFloat(e.target.value) < constdata.minInvest) {
        setError_msg(`amount must be greater ${constdata.minInvest} USD`);
        setToken(0);
        return;
      } else {
        setError_msg("");
        setToken(
          parseFloat((e.target.value * constdata.tokenPerUSD).toFixed(3))
        );
      }
    } else {
      if (isNaN(e.target.value)) {
        setToken(0);
        setError_msg("(please enter valid amount.)");
        return;
      } else if (parseFloat(e.target.value) === 0) {
        setToken(0);
        setError_msg("(please enter valid amount.)");
        return;
      } else {
        setError_msg("");
        setToken(
          parseFloat(
            e.target.value * constdata.usdtToBnb * constdata.tokenPerUSD
          ).toFixed(3)
        );
      }
    }
  };

  const handleBuynow = async (e) => {
    try {
      setLoading(true);
      console.log("IN");
      if (account) {
        let addr = referral;
        
        if (
          (paymenttype === "1" || paymenttype === "2") &&
          !isNaN(amount) &&
          amount > 0
        ) {
          
          let decimals = 18;
          if (paymenttype === "1") {
            decimals = 18;
            
          }
          
          
          
          if (true) {
            

            console.log("IN", addr);
            
            let _value = parseUnits(amount, decimals);
            console.log(_value.toString());
            console.log("paymenttype", paymenttype);

            let tx = await contract.methods
              .buyfromToken(paymenttype, addr, _value)
              .send({
                from: account,
              });

            console.log("tx", tx);
            
            if (tx) {
                toast.success(
                  "success ! Your Last Transaction is Successfull."
                );
                setLoading(false);
                setIsApprove(true);
                setRefresh(new Date());
                window.location.reload();
            
            } else {
              toast.error("Opps ! something went wrong!");
              setLoading(false);
              window.location.reload();
            }
          } else {
            toast.error("you don't have sufficient funds in your account ");
            setLoading(false);
          }
        } else {
          let response = await contract.methods.buyFromNative(addr).send({
            value: web3.utils.toWei(amount.toString(), "ether"),
            from: account,
          });
          if (response) {
            toast.success("success ! Your Last Transaction is Successfull.");
          } else {
            toast.error("User denied Signature!!.");
          }

          setLoading(false);
          window.location.reload();
        }
      } else {
        toast.error("Please Connect Wallet !");
        setLoading(false);
      }
    } catch (err) {
      
      setLoading(false);
      console.log(err);
      window.location.reload();
    }
  };

  const handleApproveToken = async (e) => {
    console.log("Approving");
    try {
      setLoading(true);
      console.log("IN");
      if (account) {
        if (paymenttype) {
          let contract;
          let decimals = 18;
          if (paymenttype === "1") {
            contract = usdt;
            decimals = 18;
          } else if (paymenttype === "2") {
            contract = busd;
          } else {
            toast.error("something went wrong ! please try again later");
            setLoading(false);
            setIsApprove(true);
            return false;
          }
          let _amount = parseUnits(amount, decimals);
          let tx =  await contract.methods.approve(constdata.presale_address, _amount).send({
            from: account,
          });
          console.log("tx", tx);
          
          if (tx) {
            
              toast.success("success ! Your Last Transaction is Successfull.");
              setLoading(false);
              setIsApprove(true);
              if (paymenttype === "1") {
                setUsdtapprove(true);
              } else if (paymenttype === "2") {
                setBusdapprove(true);
              }
          } else {
            toast.error("Opps ! something went wrong!");
            setLoading(false);
          }
        } else {
          toast.error("Please select payment type !");
          setLoading(false);
        }
      } else {
        toast.error("Please Connect Wallet !");
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="app-trade" style={{
        
      }}>
        <div className="app-trade__items grid" style={{}}>
          <div className="app-trade__item flex " style={{
            backgroundColor: "#404040",
          }}>
            <div className="app-trade__item-input">
              <div className="app-trade__token">
                <div className="form-check form-check-inline flex flex-row space-between">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    onChange={(e) => handlePaymentChange(e)}
                    id="inlineRadio1"
                    value="1"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    <img src="../images/tether.png" alt="bnb-logo" />
                    USDT
                  </label>
                </div>
                <div className="form-check form-check-inline flex flex-row space-between">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    onChange={(e) => handlePaymentChange(e)}
                    id="inlineRadio2"
                    value="2"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    <img src="../images/usdc.png" alt="bnb-logo" />
                    USDC
                  </label>
                </div>
                <div className="form-check form-check-inline flex flex-row space-between">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    onChange={(e) => handlePaymentChange(e)}
                    id="inlineRadio2"
                    value="3"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    <img src="../images/etheruem.png" alt="matic-logo" />
                    ETH
                  </label>
                </div>
              </div>
              <input
                type="text"
                style={{ border: "none", width: "100%" }}
                onChange={handleAmountChange}
                value={amount}
                className="app-trade__item-value"
                placeholder="0.0"
              />
              {/* <p>0.0</p> */}
              {/* <div className="click-box">
                <div className="lbl">Click here</div>
                <div className="tag">(Live BNB TO USD)</div>
              </div> */}
            </div>
          </div>
          <div className="app-trade__item flex" style={{
            backgroundColor: "#404040",
          }}>
            <div className="app-trade__item-info flex flex--column">
              <h3 className="app-trade__token" style={{
                fontSize: "1.5rem",
                marginLeft: "0px",
              }} >
                <img src="../images/logo.png" alt="min-logo" style={{
                  
                  width: "60px",
                  height: "60px",
                  marginTop: "-10px",


                }} />
                <p style={{
                  marginTop: "-15px",
                  marginLeft: "-10px",
                }}>KAIROS</p>
              </h3>
              <p className="app-trade__balance">
                Balance <span id="myTokens">{userbal}</span> <br />
                KAIROS{" "}
              </p>
            </div>
            <div className="app-trade__item-input">
              <div className="app-trade__item-value">
                <span id="get">~{parseInt(token)}</span>
              </div>
            </div>
          </div>
          <small className="text-danger">{error_msg}</small>
        </div>
        {isApprove ? (
          <Button
            loading={loading}
            className="btn"
            style={{ textAlign: "center", color: "#27220b" }}
            onClick={handleBuynow}
          >
            Buy Now
          </Button>
        ) : (
          <Button
            loading={loading}
            className="btn"
            style={{ textAlign: "center",color: "#27220b"  }}
            onClick={handleApproveToken}
          >
            Approve
          </Button>
        )}
      </div>
    </>
  );
}
